import styled from 'styled-components';
import { colors } from '~/styles/colors';

export const FormContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  width: 100%;
`;

export const ButtonsRow = styled.div`
  display: flex;
  align-items: center;
  margin-top: 24px;
  justify-content: center;
  gap: 8px;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  justify-content: start;
  width: 100%;

  @media (max-width: 768px) {
    padding-bottom: 24px;
  }
`;

export const ErrorSpan = styled.span`
  margin: 0;
  color: ${colors.Red};
  display: block;
  text-align: left;
  font-size: 0.75em;
  height: 16px;
`;
